export default __webpack_public_path__ + "static/media/back.aeb8c953.mp3";